<div
  #section
  [ngClass]="{
    'gap-5': hasMultipleChildren && !withoutContentPadding(),
    'p-4 px-6': !withoutContentPadding(),
    'text-[#F7FAFDDE]': isDarkMode(),
    'text-standard-text-primary bg-white': !isDarkMode() && !isDisabled(),
    'text-gray-400': isDisabled(),
    'text-black': !isDisabled(),
    'border-standard-divider border-b py-3 rounded-none':
      showDividerWhenCollapsed() && isCollapsed,
  }"
  [ngStyle]="{
    color: corporateDesignService.fontColor(),
    borderRadius: corporateDesignService.borderRadius(),
    backgroundColor: isDarkMode() ? darkModeColor() : '',
  }"
  [attr.data-testid]="'section-' + testIdAffix()"
  class="text-standard-text-primary flex flex-col rounded-lg">
  <div
    [ngClass]="{
      '-mb-4 pb-4': !withoutContentPadding(),
      'sticky top-0 z-10': isStickyHeader(),
      'text-[#F7FAFDDE]': isDarkMode(),
      'text-standard-text-primary bg-white': !isDarkMode() && !isDisabled(),
    }">
    <div
      class="flex justify-between gap-5 rounded-2xl"
      [ngStyle]="{
        flexDirection: reverseHeader() ? 'row-reverse' : 'row',
      }">
      <ng-content select="aw-section-header"></ng-content>
      @if (isCollapsible()) {
        @if (isCollapsed) {
          <aw-button
            [id]="'extend-section'"
            [type]="'button'"
            (click)="toggleCollapse()"
            [style]="'custom'"
            class="w-12"
            ><span class="material-symbols-rounded"> keyboard_arrow_down </span>
          </aw-button>
        } @else {
          <aw-button
            [id]="'collapse-section'"
            [type]="'button'"
            (click)="toggleCollapse()"
            [style]="'custom'"
            class="w-12"
            ><span class="material-symbols-rounded"> keyboard_arrow_up </span>
          </aw-button>
        }
      }
    </div>
  </div>
  @if (!isCollapsed) {
    <ng-content></ng-content>
  }
</div>
